import { Button, Col, DatePicker, Form, Input, Row, Select } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { ECapReportStepProps } from ".";
import { DateFormat, ReportTypeEnum, VALIDATION_MESSAGE_CONFIG } from "../../../../constants/constants";
import { ECAPService } from "../../../../services/ecap.service";
import { MinusIcon, PlusIcon } from "../../../atoms/icon";

const dataIntervals = [
    "Daily",
    "Monthly",
    "Quarterly",
    "Yearly"
]


const MRInput = (props: ECapReportStepProps) => {

    const { t } = useTranslation();

    const formSubmit = (values: any) => {

        const model = {
            risk_type: ReportTypeEnum.MarketRisk,
            file_index: 0,
            data: values
        }

        ECAPService.uploadJsonData(model).then(res => {
            if (props.next) {
                props.next({
                    data_file_ids: res.data.file_ids
                }, props.fileIndex);
            }
        })

    }

    return (
        <div className="step-content-item-wrapper">

            <div className="step-content-item-header">
                <h4>
                    {t("EcapModule.ttInputInformation")}
                </h4>
            </div>

            <Form
                layout='vertical'
                validateMessages={VALIDATION_MESSAGE_CONFIG}
                onFinish={(values) => formSubmit(values)}
                initialValues={{
                    confident_interval: props.resources?.target_ratings ? props.resources?.target_ratings[0] : "",
                    names_of_investments: [""]
                }}
                scrollToFirstError>
                <Form.Item
                    label={t("EcapModule.lbChooseConfidenceInterval")}
                    name="confident_interval"
                    rules={[{ required: true }]}>
                    <Select>
                        {
                            props.resources?.target_ratings && props.resources?.target_ratings?.map((item, index) => (
                                <Select.Option value={item} key={index} >
                                    {
                                        item
                                    }
                                </Select.Option>
                            ))
                        }
                    </Select>

                </Form.Item>

                <Form.Item
                    label={t("EcapModule.lbLastMonth")}
                    name="last_month_for_available_nav_and_income_data"
                    rules={[{ required: true }]}>
                    <DatePicker format={DateFormat.view} placeholder={t("Global.plPleaseSelect")}>
                    </DatePicker>
                </Form.Item>

                <Form.Item
                    label={t("EcapModule.lbFirstMonth")}
                    name="first_month_for_available_nav_and_income_data"
                    rules={[{ required: true }]}>
                    <DatePicker format={DateFormat.view} placeholder={t("Global.plPleaseSelect")}>
                    </DatePicker>
                </Form.Item>

                <Form.Item
                    label={t("EcapModule.lbDataInterval")}
                    name="data_interval"
                    rules={[{ required: true }]}>
                    <Select>
                        {
                            dataIntervals?.map((item, index) => (
                                <Select.Option value={item.toLowerCase()} key={index} >
                                    {
                                        item
                                    }
                                </Select.Option>
                            ))
                        }
                    </Select>
                </Form.Item>

                <div className="or-form-list">

                    <p className="blue-text">
                        {t("EcapModule.desInvestments")}
                    </p>

                    <Form.List
                        name="names_of_investments"
                    >

                        {(fields, { add, remove }, { errors }) => (
                            <>
                                {fields.map((field, index) => (
                                    <Form.Item
                                        key={field.key}
                                        label={index === 0 ?
                                            t("EcapModule.ttInvestments")
                                            : null}
                                    >
                                        <Form.Item
                                            {...field}
                                            name={[field.name]}
                                            rules={[
                                                { required: true, message: "" }
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>


                                        <span className="list-item-action">
                                            <PlusIcon className={`list-item-icon`} onClick={() => {
                                                add();
                                            }} />
                                        </span>
                                        <span className="list-item-action">
                                            {
                                                index > 0 && <MinusIcon onClick={() => { remove(field.name) }} />
                                            }
                                        </span>
                                    </Form.Item>
                                ))}

                            </>
                        )}
                    </Form.List>

                </div>

                <Row gutter={8}>
                    <Col span={12}>
                        <Button type="default" onClick={props.goback} block shape="round">
                            {t("Onboarding.btnGoback")}
                        </Button>
                    </Col>
                    <Col span={12}>
                        <Button htmlType="submit" type="primary" shape="round" block>
                            {
                                t("RapmReport.btnNext")
                            }
                        </Button>
                    </Col>
                </Row>

            </Form>

        </div>
    )
}

export default MRInput;